import { Component, Input } from '@angular/core';
import { InternetProduct } from '@dch/products-business-logic';
import { TranslationService } from '@proximus/ng-common';
import { openProductURL } from '../../../shared/util/my-product-apps';
import { Router } from '@angular/router';

@Component({
  selector: 'mprd-public-wifi',
  templateUrl: './public-wifi.component.html',
})
export class PublicWifiComponent {
  @Input() internetProduct: InternetProduct;
  openUrlOrApp = openProductURL;
  pageRouter;

  constructor(
    private translationService: TranslationService,
    router: Router,
  ) {
    this.pageRouter = router;
  }
}
